module.exports = __webpack_public_path__ + "static/media/7-river-rocks-08_04_2020.99126991.jpg";